exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TotalCalculator-c424756e{height:100%;max-height:595px;margin:40px 25px 40px 25px;color:#212121;display:flex;flex-direction:column}.header-3320743b{float:left;display:flex}.header-3320743b .premiumIcon-a1654ad5{font-size:19px;color:#FA6400}.header-3320743b .basicIcon-a047039f{font-size:19px;color:#212121}.header-3320743b .text-ed49775c{margin:4px 0 13px 10px}.line-7314cd45{height:2px;width:100%;border:1px solid #BDBDBD;margin:9px 0 9px 0}.costRow-c99561ed{display:flex;justify-content:space-between}.costRow-c99561ed .prorate-5ac7e85e{color:#6982FF}.total-5f706e51{font-weight:500}.prorateTerm-e8fb9243{display:flex;justify-content:flex-start;font-size:13px}.footer-1effd0f9{align-self:flex-end;margin-top:auto;display:flex;flex-direction:column;align-items:flex-start;text-align:left;font-size:13px;line-height:18px}.footer-1effd0f9 .policy-3c7de545{margin-top:10px}\n", ""]);

// Exports
exports.locals = {
	"TotalCalculator": "TotalCalculator-c424756e",
	"header": "header-3320743b",
	"premiumIcon": "premiumIcon-a1654ad5",
	"basicIcon": "basicIcon-a047039f",
	"text": "text-ed49775c",
	"line": "line-7314cd45",
	"costRow": "costRow-c99561ed",
	"prorate": "prorate-5ac7e85e",
	"total": "total-5f706e51",
	"prorateTerm": "prorateTerm-e8fb9243",
	"footer": "footer-1effd0f9",
	"policy": "policy-3c7de545"
};